import { MaterialIcon, GraviButton } from '@gravitate-js/excalibrr'
import { notification } from 'antd'
import { useState } from 'react'
import { useQueryClient } from '@tanstack/react-query'
import type { InvoiceGroup } from '../../../../../../api/useFreight/types'
import { useInvoices } from '../../../../../../api/useFreight/useInvoices'

export function ResendButton({ invoiceGroup }: { invoiceGroup: InvoiceGroup }) {
  const { useResendInvoiceMutation } = useInvoices()
  const resendInvoiceMutation = useResendInvoiceMutation()
  const queryClient = useQueryClient()
  const [loading, setLoading] = useState(false)

  const handleResendInvoice = async () => {
    // Get the most recent invoice number (assuming the first one in the array)
    const invoice_number = invoiceGroup.invoices?.[0]?.invoice_number

    setLoading(true)
    try {
      await resendInvoiceMutation.mutateAsync({
        invoice_group_id: invoiceGroup.id,
        invoice_number,
      })

      notification.success({
        message: 'Invoice Resent Successfully',
        description: `Invoice ${invoice_number} has been resent to ${invoiceGroup.counterparty_name}.`,
        placement: 'topRight',
        icon: <MaterialIcon icon='check_circle' style={{ color: 'var(--theme-success)' }} />,
      })
    } catch (error) {
      notification.error({
        message: 'Failed to Resend Invoice',
        description: 'There was an error resending the invoice. Please try again.',
        placement: 'topRight',
        icon: <MaterialIcon icon='error' style={{ color: 'var(--theme-error)' }} />,
      })
      console.error('Error resending invoice:', error)
    } finally {
      queryClient.invalidateQueries({ queryKey: ['invoice'] })
      queryClient.invalidateQueries({ queryKey: ['invoices-be-query'] })
      setLoading(false)
    }
  }

  return (
    <GraviButton
      style={{ fontWeight: 'bold' }}
      buttonText='Re-send'
      icon={<MaterialIcon icon='refresh' className='pt-1' />}
      onClick={handleResendInvoice}
      loading={loading}
    />
  )
}
